import { Module, Mutation, VuexModule } from 'vuex-module-decorators'
import { Report } from 'powerbi-client'
import { MainStore } from '~/store/index'

@Module({ namespaced: true, name: 'PowerBiModule', dynamic: true, store: MainStore })
export default class PowerBiModule extends VuexModule {
  pbiReport: Report = {} as Report

  get getPBIReport(): Report {
    return this.pbiReport
  }

  @Mutation
  setPowerbiReport(report: Report) {
    this.pbiReport = report
  }
}
